(() => {
  'use strict';
  const TS = window.ThreeSheep;
  if (!TS || window.Shopify?.designMode) return;
  const cfg = TS.config;
  const ids = { ga4: /^G-[A-Z0-9]+$/i.test(cfg.ga4 || '') ? cfg.ga4 : '', meta: /^\d+$/.test(cfg.meta || '') ? cfg.meta : '', tiktok: /^[A-Z0-9]{8,}$/i.test(cfg.tiktok || '') ? cfg.tiktok : '' };
  const loaded = { ga4: false, meta: false, tiktok: false };
  let attribution = {}, initialViewSent = false;
  const allowed = type => {
    const privacy = window.Shopify?.customerPrivacy;
    try {
      if (type === 'analytics') return privacy?.analyticsProcessingAllowed() === true;
      return privacy?.marketingAllowed() === true && privacy?.saleOfDataAllowed() === true;
    } catch { return false; }
  };
  const loadScript = (src,id) => {
    if (document.getElementById(id)) return;
    const script = document.createElement('script'); script.async = true; script.src = src; script.id = id; document.head.appendChild(script);
  };
  function google() {
    if (!ids.ga4 || loaded.ga4) return;
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function(){ window.dataLayer.push(arguments); };
    window.gtag('consent','default',{analytics_storage:'denied',ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied'});
    window.gtag('js',new Date());
    window.gtag('config',ids.ga4,{send_page_view:false});
    loadScript(`https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(ids.ga4)}`,'ThreeSheepGA4');
    loaded.ga4=true;
  }
  function meta() {
    if (!ids.meta || loaded.meta) return;
    if (!window.fbq) {
      const fbq = function(){ if(fbq.callMethod)fbq.callMethod.apply(fbq,arguments);else fbq.queue.push(arguments); };
      fbq.push=fbq;fbq.loaded=true;fbq.version='2.0';fbq.queue=[];window.fbq=fbq;
    }
    window.fbq('consent','grant');window.fbq('init',ids.meta);
    loadScript('https://connect.facebook.net/en_US/fbevents.js','ThreeSheepMeta');
    loaded.meta=true;window.fbq('track','PageView');
  }
  function tiktok() {
    if (!ids.tiktok || loaded.tiktok) return;
    window.TiktokAnalyticsObject='ttq';
    const ttq = window.ttq = window.ttq || [];
    const methods=['page','track','identify','instances','debug','on','off','once','ready','alias','group','enableCookie','disableCookie','holdConsent','revokeConsent','grantConsent'];
    methods.forEach(method=>{if(!ttq[method])ttq[method]=function(){ttq.push([method,...arguments]);};});
    ttq._i=ttq._i||{};ttq._i[ids.tiktok]=[];ttq._i[ids.tiktok]._u='https://analytics.tiktok.com/i18n/pixel/events.js';
    ttq._t=ttq._t||{};ttq._t[ids.tiktok]=Date.now();ttq._o=ttq._o||{};ttq._o[ids.tiktok]={};
    ttq.grantConsent();
    loadScript(`https://analytics.tiktok.com/i18n/pixel/events.js?sdkid=${encodeURIComponent(ids.tiktok)}&lib=ttq`,'ThreeSheepTikTok');
    loaded.tiktok=true;ttq.page();
  }
  function captureAttribution() {
    if (!allowed('marketing')) return;
    try { attribution = JSON.parse(sessionStorage.getItem('three-sheep:utm') || '{}'); } catch { attribution={}; }
    const query = new URLSearchParams(location.search); let changed=false;
    ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'].forEach(key=>{
      const value=query.get(key);if(value){attribution[key]=value.slice(0,180);changed=true;}
    });
    if (!changed) return;
    try {sessionStorage.setItem('three-sheep:utm',JSON.stringify(attribution));}catch{}
    const attributes=Object.fromEntries(Object.entries(attribution).map(([key,value])=>[`${key}__`,value]));
    TS.cart?.updateAttributes(attributes).catch(()=>{});
  }
  function track(name,payload={}) {
    const analytics=allowed('analytics'),marketing=allowed('marketing');
    if(!analytics&&!marketing)return;
    const detail={...payload,...(marketing?attribution:{})};
    if(analytics&&loaded.ga4)window.gtag('event',name,detail);
    const mapping={view_item:'ViewContent',add_to_cart:'AddToCart',begin_checkout:'InitiateCheckout'};
    if(marketing&&mapping[name]){
      const items=payload.items||[];
      if(loaded.meta)window.fbq('track',mapping[name],{value:payload.value,currency:payload.currency,content_type:'product',content_ids:items.map(item=>item.item_id),contents:items.map(item=>({id:item.item_id,quantity:item.quantity||1}))});
      if(loaded.tiktok)window.ttq.track(mapping[name],{value:payload.value,currency:payload.currency,content_type:'product',contents:items.map(item=>({content_id:item.item_id,content_name:item.item_name,quantity:item.quantity||1,price:item.price}))});
    }
    TS.emit('analytics',{name,payload:detail,permissions:{analytics,marketing}});
  }
  function consentChanged() {
    const analytics=allowed('analytics'),marketing=allowed('marketing');
    const wasGA=loaded.ga4;
    if(analytics)google();
    if(loaded.ga4){window.gtag('consent','update',{analytics_storage:analytics?'granted':'denied',ad_storage:marketing?'granted':'denied',ad_user_data:marketing?'granted':'denied',ad_personalization:marketing?'granted':'denied'});if(analytics&&!wasGA)window.gtag('event','page_view');}
    if(marketing){meta();tiktok();captureAttribution();}
    else{
      if(loaded.meta)window.fbq('consent','revoke');if(loaded.tiktok)window.ttq.revokeConsent();
      attribution={};try{sessionStorage.removeItem('three-sheep:utm');}catch{}
    }
    if(marketing&&loaded.meta)window.fbq('consent','grant');
    if(marketing&&loaded.tiktok)window.ttq.grantConsent();
    if(!initialViewSent&&(analytics||marketing)){
      const node=document.querySelector('[data-selected-variant]');
      if(node){const variant=JSON.parse(node.textContent);initialViewSent=true;track('view_item',{currency:cfg.currency,value:variant.price/100,items:[{item_id:String(variant.id),item_name:variant.title,item_variant:variant.variantTitle,price:variant.price/100,quantity:1}]});}
    }
  }
  ['add_to_cart','begin_checkout','newsletter_submit'].forEach(name=>document.addEventListener(`three-sheep:${name}`,event=>track(name,event.detail)));
  document.addEventListener('visitorConsentCollected',consentChanged);
  const initialize = () => {
    if(window.Shopify?.customerPrivacy)consentChanged();
    else if(window.Shopify?.loadFeatures)window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error)consentChanged();});
  };
  initialize();
  addEventListener('load',initialize,{once:true});
})();
